export const PACKING_CLASS_LIVE = 'live';
export const PACKING_CLASS_DRY = 'dry';

const PACKING_CLASS_BY_LISTING_TYPE = {
  live_goods: PACKING_CLASS_LIVE,
  dry_goods: PACKING_CLASS_DRY,
  reef_art_apparel: PACKING_CLASS_DRY,
};

export const packingClassForListingType = listingType =>
  PACKING_CLASS_BY_LISTING_TYPE[listingType] || null;

export const getFreeShippingOffer = (publicData, packingClass) => {
  if (packingClass === PACKING_CLASS_LIVE) {
    const enabled = publicData?.freeShippingLiveEnabled === true;
    const thresholdSubunits = publicData?.freeShippingLiveThresholdSubunits;
    if (!enabled || typeof thresholdSubunits !== 'number' || thresholdSubunits <= 0) {
      return { enabled: false, thresholdSubunits: null };
    }
    return { enabled: true, thresholdSubunits };
  }
  if (packingClass === PACKING_CLASS_DRY) {
    const enabled = publicData?.freeShippingDryEnabled === true;
    const thresholdSubunits = publicData?.freeShippingDryThresholdSubunits;
    if (!enabled || typeof thresholdSubunits !== 'number' || thresholdSubunits <= 0) {
      return { enabled: false, thresholdSubunits: null };
    }
    return { enabled: true, thresholdSubunits };
  }
  return { enabled: false, thresholdSubunits: null };
};

export const freeShippingProgress = ({ merchandiseSubunits, thresholdSubunits }) => {
  const merch = typeof merchandiseSubunits === 'number' ? merchandiseSubunits : 0;
  const threshold = typeof thresholdSubunits === 'number' ? thresholdSubunits : 0;
  const remainingSubunits = Math.max(threshold - merch, 0);
  return { met: threshold > 0 && merch >= threshold, remainingSubunits };
};
